var map = {
	"./aeronautics.svg": 30755,
	"./agriculture_fishing.svg": 89229,
	"./arts_design.svg": 31002,
	"./automotive.svg": 3596,
	"./banking_insurance.svg": 9606,
	"./banking_microfinance.svg": 41908,
	"./beauty_cosmetics.svg": 68438,
	"./communications_media.svg": 21181,
	"./computers_software.svg": 90381,
	"./construction_renovation.svg": 43168,
	"./consulting_business.svg": 39132,
	"./education_academic.svg": 26311,
	"./electronics.svg": 52632,
	"./energy_utilities.svg": 12650,
	"./engineering_architecture.svg": 2986,
	"./entertainment_events.svg": 52441,
	"./financial_services.svg": 26767,
	"./fitness.svg": 38737,
	"./governmental.svg": 81197,
	"./handicraft.svg": 95521,
	"./health_care.svg": 13135,
	"./housekeeping_maintenance.svg": 95978,
	"./human_resources.svg": 24852,
	"./import_export.svg": 42553,
	"./legal_accounting.svg": 63838,
	"./manufacturing.svg": 9307,
	"./marketing_advertising.svg": 63234,
	"./non_profit_social.svg": 66977,
	"./outsourcing_leasing.svg": 5409,
	"./raw_materials.svg": 73920,
	"./real_estate.svg": 26042,
	"./restaurant_hospitality.svg": 42761,
	"./retail_wholesale.svg": 75495,
	"./security.svg": 26069,
	"./telecommunications.svg": 18780,
	"./textile_fashion.svg": 22195,
	"./transportation_logistics.svg": 68153,
	"images/industries-icons/aeronautics.svg": 30755,
	"images/industries-icons/agriculture_fishing.svg": 89229,
	"images/industries-icons/arts_design.svg": 31002,
	"images/industries-icons/automotive.svg": 3596,
	"images/industries-icons/banking_insurance.svg": 9606,
	"images/industries-icons/banking_microfinance.svg": 41908,
	"images/industries-icons/beauty_cosmetics.svg": 68438,
	"images/industries-icons/communications_media.svg": 21181,
	"images/industries-icons/computers_software.svg": 90381,
	"images/industries-icons/construction_renovation.svg": 43168,
	"images/industries-icons/consulting_business.svg": 39132,
	"images/industries-icons/education_academic.svg": 26311,
	"images/industries-icons/electronics.svg": 52632,
	"images/industries-icons/energy_utilities.svg": 12650,
	"images/industries-icons/engineering_architecture.svg": 2986,
	"images/industries-icons/entertainment_events.svg": 52441,
	"images/industries-icons/financial_services.svg": 26767,
	"images/industries-icons/fitness.svg": 38737,
	"images/industries-icons/governmental.svg": 81197,
	"images/industries-icons/handicraft.svg": 95521,
	"images/industries-icons/health_care.svg": 13135,
	"images/industries-icons/housekeeping_maintenance.svg": 95978,
	"images/industries-icons/human_resources.svg": 24852,
	"images/industries-icons/import_export.svg": 42553,
	"images/industries-icons/legal_accounting.svg": 63838,
	"images/industries-icons/manufacturing.svg": 9307,
	"images/industries-icons/marketing_advertising.svg": 63234,
	"images/industries-icons/non_profit_social.svg": 66977,
	"images/industries-icons/outsourcing_leasing.svg": 5409,
	"images/industries-icons/raw_materials.svg": 73920,
	"images/industries-icons/real_estate.svg": 26042,
	"images/industries-icons/restaurant_hospitality.svg": 42761,
	"images/industries-icons/retail_wholesale.svg": 75495,
	"images/industries-icons/security.svg": 26069,
	"images/industries-icons/telecommunications.svg": 18780,
	"images/industries-icons/textile_fashion.svg": 22195,
	"images/industries-icons/transportation_logistics.svg": 68153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40000;